import React from "react";
import "../../styles/ServicePages.css";

const WarehousingPage = () => {
  return (
    <div className="service-page">
      {/* Hero Section */}
      <div className="service-hero">
        <h1>🏭 Warehousing Solutions</h1>
        <p>Modern, secure facilities with advanced technology and flexible storage options to meet your evolving logistics needs</p>
      </div>

      {/* Main Content */}
      <div className="service-content">
        {/* Overview */}
        <section className="overview-section">
          <h2>Why Our Warehousing?</h2>
          <p className="overview-text">
            AROCL offers state-of-the-art warehousing infrastructure with integrated WMS (Warehouse Management Systems), 
            ensuring real-time inventory visibility, efficient operations, and maximum value for your goods.
          </p>
        </section>

        {/* Features Grid */}
        <section className="features-grid">
          <div className="feature-card">
            <span className="feature-icon">📊</span>
            <h3>WMS Integration</h3>
            <p>Advanced Warehouse Management Systems for real-time tracking and inventory optimization</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">❄️</span>
            <h3>Cold Storage</h3>
            <p>Temperature-controlled facilities for pharmaceuticals, food, and perishable goods</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🔐</span>
            <h3>Security & Safety</h3>
            <p>24/7 surveillance, fire suppression systems, and comprehensive insurance coverage</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">📦</span>
            <h3>Value-Added Services</h3>
            <p>Packaging, labeling, kitting, fulfillment, and reverse logistics solutions</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🚚</span>
            <h3>Flexible Options</h3>
            <p>Contract logistics, on-demand storage, and customizable fulfillment centers</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">⚡</span>
            <h3>Swift Operations</h3>
            <p>Fast processing, automated systems, and efficient order fulfillment</p>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="benefits-section">
          <h2>Key Benefits</h2>
          <div className="benefits-list">
            <div className="benefit-item">
              <span className="benefit-check">✅</span>
              <div className="benefit-text">
                <h4>Cost Efficiency</h4>
                <p>Reduce inventory carrying costs with optimized storage solutions</p>
              </div>
            </div>
            <div className="benefit-item">
              <span className="benefit-check">✅</span>
              <div className="benefit-text">
                <h4>Scalability</h4>
                <p>Easily scale storage capacity as your business grows</p>
              </div>
            </div>
            <div className="benefit-item">
              <span className="benefit-check">✅</span>
              <div className="benefit-text">
                <h4>Real-Time Visibility</h4>
                <p>Complete inventory transparency with WMS integration</p>
              </div>
            </div>
            <div className="benefit-item">
              <span className="benefit-check">✅</span>
              <div className="benefit-text">
                <h4>Compliance Ready</h4>
                <p>Meet industry standards and regulatory requirements</p>
              </div>
            </div>
          </div>
        </section>

        {/* Process Section */}
        <section className="process-section">
          <h2>Our Warehousing Process</h2>
          <div className="process-timeline">
            <div className="process-step">
              <div className="step-number">1</div>
              <h3>Intake & Receiving</h3>
              <p>Goods are received, inspected, and logged into the WMS system for immediate tracking</p>
            </div>
            <div className="process-step">
              <div className="step-number">2</div>
              <h3>Storage & Organization</h3>
              <p>Items are organized in optimal locations and properly coded for easy retrieval</p>
            </div>
            <div className="process-step">
              <div className="step-number">3</div>
              <h3>Value-Added Services</h3>
              <p>Packaging, labeling, kitting, and other services enhance your products</p>
            </div>
            <div className="process-step">
              <div className="step-number">4</div>
              <h3>Pick & Fulfillment</h3>
              <p>Orders are picked, packed, and prepared for shipment with accuracy verification</p>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="stats-section">
          <div className="stat-card">
            <div className="stat-number">150K+</div>
            <div className="stat-label">Sq. Ft. Capacity</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">99.9%</div>
            <div className="stat-label">Accuracy Rate</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">24/7</div>
            <div className="stat-label">Operations</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">500+</div>
            <div className="stat-label">Active Clients</div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <h2>Ready to Optimize Your Storage?</h2>
          <p>Let's discuss how our warehousing solutions can streamline your supply chain and reduce operational costs.</p>
          <div className="cta-buttons">
            <button className="cta-btn cta-btn-primary" onClick={() => window.location.href = "tel:+919876543210"}>📞 Call Now</button>
            <button className="cta-btn cta-btn-secondary" onClick={() => window.location.href = "https://wa.me/919876543210?text=Hi! I'm interested in your warehousing solutions."}>💬 Chat on WhatsApp</button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default WarehousingPage;
